module.exports = __webpack_public_path__ + "img/Office.e6dea541.jpg";